import { render } from "./evaluationDetail.vue?vue&type=template&id=51e34541&scoped=true"
import script from "./evaluationDetail.vue?vue&type=script&lang=js"
export * from "./evaluationDetail.vue?vue&type=script&lang=js"

import "./evaluationDetail.vue?vue&type=style&index=0&id=51e34541&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e34541"]])

export default __exports__